export default __webpack_public_path__ + "static/media/smiles-gif.203dcce1.gif";